<template>
  <Dialog :open="open" @update:open="$emit('update:open', $event)">
    <DialogContent class="max-w-md">
      <DialogHeader>
        <DialogTitle>{{ t('backorder_confirmation.title') }}</DialogTitle>
      </DialogHeader>

      <div class="space-y-4">
        <p class="text-sm text-gray-600">
        {{ t('backorder_confirmation.content.line1') }}
        </p>
        <p class="text-sm text-gray-600">
        {{ t('backorder_confirmation.content.line2') }}
        </p>

        <div class="flex items-start space-x-2">
          <Checkbox 
            id="backorder-acknowledgment" 
            v-model:model-value="acknowledged" 
            :required="true"
            class="mt-1"
          />
          <Label 
            for="backorder-acknowledgment" 
            class="text-sm leading-5 cursor-pointer"
          >
            {{ t('backorder_confirmation.checkbox') }}
          </Label>
        </div>

        <div class="text-xs text-gray-600">
          {{ t('backorder_confirmation.content.line3') }}
          <a :href="`https://shop.pogliani.com/${locale}/termini-e-condizioni`" 
             class="underline hover:no-underline ml-1" 
             target="_blank" 
             rel="noopener">{{ t('Terms of Sale') }}</a>
          {{ t('and') }}
          <a :href="`https://shop.pogliani.com/${locale}/faqs-2`" 
             class="underline hover:no-underline ml-1" 
             target="_blank" 
             rel="noopener">{{ t('FAQ') }}</a>
        </div>
      </div>

      <DialogFooter>
        <Button 
          @click="handleConfirm" 
          :disabled="!acknowledged || loading"
          class="w-full"
        >
          <SfProgressCircular v-show="loading" class="mr-2!" size="sm" />
          {{ t('backorder_confirmation.button') }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { Button } from '~/components/ui/button';
import { Checkbox } from '~/components/ui/checkbox';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Label } from '~/components/ui/label';
import { SfProgressCircular } from '@storefront-ui/vue';

interface Props {
  open: boolean;
  loading?: boolean;
  requestedQuantity?: number;
  availableQuantity?: number;
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  requestedQuantity: 0,
  availableQuantity: 0,
});

const emit = defineEmits<{
  'update:open': [value: boolean];
  'confirm': [];
}>();

const { t, locale } = useI18n();
const acknowledged = ref(false);

function handleConfirm() {
  if (!acknowledged.value) return;
  emit('confirm');
}

// Reset acknowledgment when modal closes
watch(() => props.open, (newOpen) => {
  if (!newOpen) {
    acknowledged.value = false;
  }
});
</script>